
import body_bg from "../assets/img/Galaxy.mp4";
import LandPic from "../assets/img/land1.jpg"

const Background = () => {
  return (
    <>
{/* 
 <img src={LandPic} className="LandPic"/> */}

        <div className="video-layout" />
      <video
        className="video-bg"
        width={300}
        height={200}
        preload="auto"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={body_bg} type="video/mp4" />
      </video>  

<span className="Land-span-bg"></span>
 
    </>
  );
};

export default Background;
